import { registerPlugin } from '@capacitor/core'

import { isAndroid } from '@/utils/device-type'

import type { PrinterConfig, PrinterDriver } from '../types'
import { EscPosEncoder } from './esc-pos-encoder'

const plugin = registerPlugin<{
  sendData: ({ data }: { data: string }) => Promise<void>
  discoverPrinters: () => Promise<{ printers: { id: string; name: string }[] }>
}>('UsbAndroid')

export default class UsbAndroid implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  async printImage(canvas: HTMLCanvasElement) {
    const width = 504
    const ratio = width / canvas.width
    const height = Math.round((canvas.height * ratio) / 8) * 8
    const encoder = new EscPosEncoder()
    const result = encoder
      .align('center')
      .image(canvas, width, height)
      .newline(5)
      .cut('partial')
      .encodeAsBase64()

    await plugin.sendData({ data: result })
  }

  async openCashDrawer() {
    const result = new EscPosEncoder().openCashDrawer().encodeAsBase64()
    await plugin.sendData({ data: result })
  }

  static discoverPrinters(): Promise<{ id: string; name: string }[]> {
    if (!isAndroid) return Promise.resolve([])
    return plugin.discoverPrinters().then(({ printers }) => printers)
  }
}
